import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { spacings } from "themes/variables"
import FileItem from "./FileItem"
import styles from "../index.module.css"

/**
 * List of uploaded files
 */
const FilesList = ({ files, onDeleteClick }) => {
  if (files.length === 0) {
    return null
  }

  return (
    <Flex vertical gap={spacings.S} className={styles.fileItemWrapper}>
      {files.map((file) => (
        <FileItem key={file.uid} file={file} onDelete={onDeleteClick} />
      ))}
    </Flex>
  )
}

FilesList.propTypes = {
  files: PropTypes.arrayOf(
    PropTypes.shape({
      uid: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      status: PropTypes.string,
      percent: PropTypes.number
    })
  ).isRequired,
  onDeleteClick: PropTypes.func.isRequired
}

export default FilesList
